import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Umzugsservice() {
  return (
    <ServiceLayout
      title="Umzugsservice in Augsburg"
      description="Zuverlässiger Umzugsservice mit Erfahrung, schneller Abwicklung und kompletter Unterstützung – flexibel, sicher und kundenorientiert."
      image="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df932922ae9c1fe6eaa1.jpg"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Stressfrei umziehen mit Profis
          </h2>
          <p className="text-lg text-neutral-600">
            Ein Umzug bedeutet oft Stress und viel Aufwand. Mit unserem erfahrenen Team aus Augsburg wird Ihr Wohnungswechsel jedoch zur entspannten Angelegenheit. Wir übernehmen nicht nur den sicheren Transport Ihrer Möbel und Kartons, sondern bieten Ihnen einen umfassenden Service von A bis Z.
          </p>
          <p className="text-lg text-neutral-600">
            Egal ob Privatumzug oder Firmenumzug, wir planen jeden Schritt präzise. Unsere geschulten Mitarbeiter gehen behutsam mit Ihrem Eigentum um und dank unseres Kravag-Logistik Versicherungsschutzes sind Sie in jedem Fall auf der sicheren Seite.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Kostenlose Vorab-Besichtigung",
              "Sicherer Transport & Verpackung",
              "Demontage und Montage inklusive",
              "Vollständig versichert"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr professioneller Umzugsservice in Augsburg und Umgebung</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Umzug ist mehr als nur der Transport von Möbeln und Kartons von A nach B. Es ist der Start in einen neuen Lebensabschnitt. Als Ihr verlässlicher Umzugsservice in Augsburg wissen wir, wie wichtig ein reibungsloser, stressfreier und pünktlicher Ablauf ist. Mit über 10 Jahren Erfahrung in der Umzugsbranche haben wir unzählige Privat- und Firmenumzüge erfolgreich durchgeführt. Unser Ziel ist es, Ihnen die Last des Umzugs vollständig abzunehmen, damit Sie sich auf Ihr neues Zuhause oder Ihre neuen Geschäftsräume freuen können.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Unser engagiertes Team aus erfahrenen Umzugshelfern, Monteuren und Handwerkern arbeitet Hand in Hand. Wir bieten Ihnen nicht nur die reine Transportleistung, sondern ein Rundum-Sorglos-Paket. Von der ersten kostenlosen Vorab-Besichtigung über die detaillierte Planung bis hin zur finalen Möbelmontage und Endreinigung – wir stehen Ihnen als kompetenter Partner zur Seite. Dabei legen wir größten Wert auf Transparenz: Bei uns gibt es keine versteckten Kosten. Sie erhalten ein faires, maßgeschneidertes Angebot, das exakt auf Ihre Bedürfnisse zugeschnitten ist.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Egal ob Sie in eine kleine Wohnung oder ein großes Einfamilienhaus ziehen – wir behandeln Ihr Hab und Gut mit größter Sorgfalt. Wir kümmern uns um das fachgerechte Einpacken von zerbrechlichen Gegenständen, den sicheren Transport und den Aufbau Ihrer Möbel am Zielort. Auch bei schwierigen Gegebenheiten wie engen Treppenhäusern oder fehlenden Aufzügen finden wir die passende Lösung.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Firmen- & Büroumzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Zeit ist Geld, besonders bei einem Firmenumzug. Wir planen Ihren Büroumzug so, dass Ausfallzeiten für Ihr Unternehmen auf ein absolutes Minimum reduziert werden. Wir transportieren nicht nur Büromöbel, sondern auch sensible IT-Infrastruktur sicher und zuverlässig. Auf Wunsch führen wir den Umzug auch am Wochenende durch, damit Sie am Montag direkt wieder am neuen Standort durchstarten können.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Umfassende Leistungen für Ihren perfekten Umzug</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein professioneller Umzug erfordert eine exakte Planung und das richtige Equipment. Als Full-Service-Umzugsunternehmen in Augsburg bringen wir nicht nur das nötige Know-how, sondern auch modernste Ausrüstung mit. Vom passenden Verpackungsmaterial über spezielle Transportdecken für empfindliche Möbel bis hin zu Tragegurten und professionellem Werkzeug für die Demontage – wir sind auf alles vorbereitet.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Unsere Leistungen gehen weit über das übliche Tragen von Kartons hinaus. Wir bieten Ihnen professionelle Möbelmontage, bei der selbst komplexe Schrankwände oder hochwertige Einbauküchen fachmännisch abgebaut und am neuen Wohnort wieder passgenau aufgebaut werden. Auch weitere Handwerksarbeiten übernehmen unsere qualifizierten Mitarbeiter gerne für Sie. So müssen Sie nicht verschiedene Handwerker koordinieren, sondern erhalten alles aus einer Hand.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">100% Versicherungsschutz – Ihre Sicherheit steht an erster Stelle</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Trotz größter Vorsicht und Professionalität kann bei einem Umzug immer mal etwas Unvorhergesehenes passieren. Damit Sie sich absolut keine Sorgen machen müssen, sind alle unsere Umzüge über die renommierte Kravag-Logistik Versicherung umfassend abgesichert. Dies bedeutet für Sie: Im unwahrscheinlichen Fall eines Schadens an Ihrem Eigentum während des Transports oder der Montage, sind Sie vollständig geschützt. Wir übernehmen die volle Verantwortung für Ihr Hab und Gut, von der ersten Minute bis zur finalen Übergabe.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Warum Easy Umzug in Augsburg?</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Maximale Sicherheit</h3>
                    <p className="text-neutral-400">Vollständiger Versicherungsschutz für all Ihre Gegenstände während des gesamten Umzugsprozesses.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Pünktlichkeit & Schnelligkeit</h3>
                    <p className="text-neutral-400">Wir halten uns strikt an vereinbarte Termine und arbeiten effizient, um Ihren Umzug zügig abzuschließen.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Erfahrenes Personal</h3>
                    <p className="text-neutral-400">Unsere Mitarbeiter sind geschult, freundlich und wissen genau, wie sie auch sensible Möbelstücke behandeln müssen.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
